import { authenticatedFetch } from '../../api/request';

export default async function fetchDoctorProfile(doctorId, onFail) {
   
    return await authenticatedFetch(`/search-doctors/get-doctor-profile/${doctorId}`, onFail);
}
